'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import View_Dialog2Button2 from '../../../lib/views/dialog2Button2/dialog2Button2';
import * as Entities_Empty from '../../../lib/entities/empty';
import * as Entities_Memory from '../../entities/memory';
import * as Entities_Memory_PositionPageable from '../../entities/memoryPositionPageable';

import helper_infopage from '../../helper/infopage';
import View_Render from '../render/render';

//import View_Setting from './setting';

import tpl_customEventThemeColorListitem from './tpl/customEventThemeColorListitem.html';

export default Marionette.ItemView.extend({
    //className: 'col-6 col-sm-6 col-md-6 col-lg-3 col-xl-2',
    attributes: function () {
        return {
            style: "display:inline-block;"
        };
    },
    getTemplate: function () {
        return tpl_customEventThemeColorListitem({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
        this.listenTo(this.model, 'change', this.render);
        //this.model.bind('destroy', this.remove, this);
    },
    ui: {
        'customEventThemeColorListitem_btnSubmit': '#customEventThemeColorListitem_btnSubmit',
        //'customEventThemeColorListitem_image': '#customEventThemeColorListitem_image',
        'customEventThemeColorListitem_div01': '#customEventThemeColorListitem_div01',
        'customEventThemeColorListitem_div02': '#customEventThemeColorListitem_div02',
        'customEventThemeColorListitem_div03': '#customEventThemeColorListitem_div03',
        'customEventThemeColorListitem_iCopy': '#customEventThemeColorListitem_iCopy',
        'customEventThemeColorListitem_iSetting': '#customEventThemeColorListitem_iSetting',
        'customEventThemeColorListitem_iEye': '#customEventThemeColorListitem_iEye',
        'customEventThemeColorListitem_iDelete': '#customEventThemeColorListitem_iDelete',
        'customEventThemeColorListitem_div_inner': '#customEventThemeColorListitem_div_inner',
        'customEventThemeColorListitem_div_html': '#customEventThemeColorListitem_div_html',

        'e4us_maincolor_01': '#e4us_maincolor_01',
        'e4us_maincolor_02': '#e4us_maincolor_02',
        'e4us_maincolor_03': '#e4us_maincolor_03',
        'e4us_navbar_toggler_01': '#e4us_navbar_toggler_01',
        'e4us_navbar_toggler_icon': '#e4us_navbar_toggler_icon',
        'e4us_menucolor02_01': '#e4us_menucolor02_01',
        'e4us_menucolor02_02': '#e4us_menucolor02_02',
        'e4us_menucolor02_03': '#e4us_menucolor02_03',
        'e4us_menucolor02_04': '#e4us_menucolor02_04',
        'e4us_menucolor02_05': '#e4us_menucolor02_05',
        'e4us_menucolor01_01': '#e4us_menucolor01_01',
        'e4us_menucolor01_02': '#e4us_menucolor01_02',
        'e4us_menucolor01_03': '#e4us_menucolor01_03',
        'e4us_menucolor01_04': '#e4us_menucolor01_04',
        'e4us_menucolor01_05': '#e4us_menucolor01_05',
        'e4us_menucolor01_06': '#e4us_menucolor01_06',
        'e4us_menucolor01_07': '#e4us_menucolor01_07',
        'e4us_menucolor01_08': '#e4us_menucolor01_08',
        'e4us_backgroundcolor_01': '#e4us_backgroundcolor_01',
        'e4us_backgroundcolor_02': '#e4us_backgroundcolor_02',
        'windowMenu_icon01': '#windowMenu_icon01',
        'windowMenu_icon02': '#windowMenu_icon02',
        'windowMenu_icon03': '#windowMenu_icon03',
        'windowMenu_icon04': '#windowMenu_icon04',
        'windowMenu_icon05': '#windowMenu_icon05',
        'windowMenu_icon06': '#windowMenu_icon06',
        'windowMenu_icon07': '#windowMenu_icon07',
        'windowMenu_icon08': '#windowMenu_icon08',
        'windowMenu_icon09': '#windowMenu_icon09',
        'windowMenu_icon10': '#windowMenu_icon10',
        'windowMenu_icon11': '#windowMenu_icon11',
        'windowMenu_icon12': '#windowMenu_icon12',
        'windowMenu_a01': '#windowMenu_a01',
        'windowMenu_a02': '#windowMenu_a02',
        'windowMenu_a03': '#windowMenu_a03',
        'windowMenu_a04': '#windowMenu_a04',
        'windowMenu_a05': '#windowMenu_a05',
        'windowMenu_a06': '#windowMenu_a06',
        'windowMenu_a07': '#windowMenu_a07',
        'windowMenu_a08': '#windowMenu_a08',
        'windowMenu_a09': '#windowMenu_a09',
        'windowMenu_a10': '#windowMenu_a10',
        'windowMenu_a11': '#windowMenu_a11',
        'windowMenu_a12': '#windowMenu_a12',
        'windowMenu_div': '#windowMenu_div',
        'region001_1': '#region001_1',
        'region001_2': '#region001_2',
        'region001_3': '#region001_3',
        'hfont_01': '#hfont_01',
        'hfont_02': '#hfont_02',
        'hfont_03': '#hfont_03',
        'hfont_04': '#hfont_04',
        'pfont_01': '#pfont_01',
        'pfont_02': '#pfont_02'
    },
    events: {
        'click @ui.customEventThemeColorListitem_div01': 'btnSubmitClick',
        'click @ui.customEventThemeColorListitem_div02': 'btnSubmitClick',
        'click @ui.customEventThemeColorListitem_div03': 'btnSubmitClick',
        'click @ui.customEventThemeColorListitem_iCopy': 'iCopyClick',
        'click @ui.customEventThemeColorListitem_iSetting': 'iSettingClick',
        'click @ui.customEventThemeColorListitem_iEye': 'iEyeClick',
        'click @ui.customEventThemeColorListitem_iDelete': 'iDeleteClick'
    },
    onRender: function () {
        var self = this;

        if (this.model.attributes.Selected) {
            this.ui.customEventThemeColorListitem_div_inner.css('border-style', 'solid');
            this.ui.customEventThemeColorListitem_div_inner.css('border-color', 'black');
        }
        else {
            this.ui.customEventThemeColorListitem_div_inner.css('border-style', 'solid');
            this.ui.customEventThemeColorListitem_div_inner.css('border-color', 'white');
        }


        //if (this.model.attributes.Selected) {
        //    this.ui.customEventThemeColorListitem_btnSubmit.css('border-style', 'solid');
        //    this.ui.customEventThemeColorListitem_btnSubmit.css('border-color', 'black');
        //}
        //else {
        //    //this.ui.customEventThemeColorListitem_btnSubmit.css('border-style', 'none');
        //    this.ui.customEventThemeColorListitem_btnSubmit.css('border-style', 'solid');
        //    this.ui.customEventThemeColorListitem_btnSubmit.css('border-color', 'white');
        //}

        this.ui.customEventThemeColorListitem_btnSubmit.css('border-color', self.model.attributes.MenuColorApp_ForeGround );

        /*var borderStyle = self.app.entities.collections.ModuleBorderStyle.findIndex(function (post, index) {
            if (post.Value == self.model.attributes.BorderStyle)
                return true;
        });


        var borderStyle = self.app.entities.collections.ModuleBorderStyle.forEach(function (entry) {
            if (entry.Value == self.model.attributes.BorderStyle)
                return true;
        });*/

        //var style = self.app.entities.collections.ModuleBorderStyle.where({ Value: self.model.attributes.BorderStyle })[0].attributes.Style;

        //if (this.model.attributes.Border) {
            //style.forEach(styleValue => self.ui.customEventThemeColorListitem_div.css(styleValue.Name, styleValue.Value));
            //self.ui.customEventThemeColorListitem_div.css('border-color', this.model.attributes.BorderColor);
            //self.ui.customEventThemeColorListitem_div.css('border-width', this.model.attributes.BorderSize);
       // }
        //else {
         //   self.ui.customEventThemeColorListitem_div.css('border-style', 'none');
       // }

        
        //self.ui.customEventThemeColorListitem_div.css('border-style', 'solid');

        //self.ui.customEventThemeColorListitem_div.css('margin-top', this.model.attributes.MarginTop + 'px');
        //self.ui.customEventThemeColorListitem_div.css('margin-bottom', this.model.attributes.MarginBottom + 'px');
        //self.ui.customEventThemeColorListitem_div.css('margin-left', this.model.attributes.MarginLeft + 'px');
        //self.ui.customEventThemeColorListitem_div.css('margin-right', this.model.attributes.MarginRight + 'px');


        //switch (this.model.attributes.BackGroundType) {
        //    case "0": self.ui.customEventThemeColorListitem_div.css('background-color', this.model.attributes.BackGroundColorApp); break;
        //    case "1": self.ui.customEventThemeColorListitem_div.css('background-color', this.model.attributes.BackGroundColor); break;
        //}

        self.ui.customEventThemeColorListitem_div01.css('background-color', this.model.attributes.MenuColorApp_BackGround);
        self.ui.customEventThemeColorListitem_div02.css('background-color', this.model.attributes.BackGroundColorApp);
        self.ui.customEventThemeColorListitem_div03.css('background-color', this.model.attributes.MenuColorApp_BackGround);

        switch (this.model.attributes.Standard) {
            case 0:
                self.ui.customEventThemeColorListitem_iDelete.css('display', 'none');
                self.ui.customEventThemeColorListitem_iSetting.css('display', 'none');
                break;
            case 1:
                self.ui.customEventThemeColorListitem_iSetting.css('display', 'none');
                self.ui.customEventThemeColorListitem_iEye.css('display', 'none');
                break;
            case 2:
                self.ui.customEventThemeColorListitem_iEye.css('display', 'none');
                break;
        }

        //self.ui.customEventThemeColorListitem_div.css('opacity', this.model.attributes.BackGroundColorOpacity / 100);

        /*var backGroundImagePosition = self.app.entities.collections.ModuleBackGroundImagePosition.findIndex(function (post, index) {
            if (post.Value == self.model.attributes.BackGroundImagePosition)
                return true;
        });
        var style = self.app.entities.collections.ModuleBackGroundImagePosition[backGroundImagePosition].Style;
        */
        //var style = self.app.entities.collections.ModuleBackGroundImagePosition.where({ Value: self.model.attributes.BackGroundImagePosition })[0].attributes.Style;
        //style.forEach(styleValue => self.ui.customEventThemeColorListitem_div.css(styleValue.Name, styleValue.Value));

        /*switch (this.model.attributes.BackGroundType) {
            case "0": self.ui.customEventThemeColorListitem_div.css('background-image', 'none'); break;
            case "1": self.ui.customEventThemeColorListitem_div.css('background-image', 'none'); break;
            case "2": self.ui.customEventThemeColorListitem_div.css('background-image', String.format("url('{0}'", self.model.attributes.BackGroundImage_InfoImage_ImageUrl));
                break;
        }*/

        this.setupCss();
    },
    btnSubmitClick: function (event) {
        var self = this;
        //this.model.collection.pageableCollection.fullCollection.each(function (tmpModel) {
        //    if ((tmpModel.attributes.Selected == true) && (tmpModel.attributes.id != self.model.attributes.id)) {
        //        tmpModel.set({ Selected: false });
        //    }
        //});

        this.model.collection.each(function (tmpModel) {
            if ((tmpModel.attributes.Selected == 1) && (tmpModel.attributes.id != self.model.attributes.id)) {
                tmpModel.set({ Selected: 0 });
            }
        });

        this.model.set({ Selected: 1 });
        this.model.collection.trigger('change');

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('customHeader:iconSave');
        helper_infopage.updateFontFromTheme(this.options.localSetting.attributes.EventId, this.app);

        var customEvent = this.app.entities.collections.customEvent.fullCollection.where({ id: this.options.localSetting.attributes.EventId });
        var render = new View_Render({ collection: customEvent, app: this.app });
        parent.app.renderRegion.show(render);
        var renderFinishCallback = function (options) {
        }
        render.doIt(renderFinishCallback, true, 'EVENT_REFRESH', true);
    },

    iCopyClick: function (event) {
        var tmpModel = this.model.clone();

        tmpModel.attributes.id = -1;
        //tmpModel.attributes.Name = self.ui.customEventThemeColorInsert_inputPush.val();
        var position = -1;
        this.options.mainCollection.forEach(function (entry) {
            if (entry.attributes.Position >= position) {
                position = entry.attributes.Position;
            }
        });

        position += 1;

        tmpModel.attributes.id = position;
        tmpModel.attributes.Position = position;
        tmpModel.attributes.Standard = 2;
        tmpModel.attributes.Default = false;
        tmpModel.attributes.ListOrig = 0;
        tmpModel.attributes.Selected = 0;

        tmpModel.attributes.Name = resources.X101560;

        this.options.mainCollection.add(tmpModel);

        var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.localSetting.attributes.EventId, ModuleType: 98 })[0];
        var data = JSON.parse(customModule.attributes.Data);
        var customModule_data = new Entities_Memory.Model(data[0].Data);
        var tmpCollection = new Entities_Memory_PositionPageable.Collection(data[0].Data.ThemeCollection);

        customModule_data.attributes.ThemeCollection = this.options.mainCollection.toJSON();
        var strJson = JSON.stringify(customModule_data.toJSON());
        customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

        customModule.save(customModule.attribute, {
            silent: false,
            wait: true,
            success: function () {
            }
        });

    },
    iSettingClick: function (event) {
        var scroll = $(document).scrollTop();
        self.app.router.navigate("#customEventThemeColorEditItem?id=" + this.options.localSetting.attributes.EventId);
        self.app.router.customEventThemeColorEditItem(this.options.localSetting.attributes.EventId, scroll, this.model.attributes.id, this.model.attributes.ListOrig);
    },
    iEyeClick: function (event) {
        var scroll = $(document).scrollTop();
        self.app.router.navigate("#customEventThemeColorEditItem?id=" + this.options.localSetting.attributes.EventId);
        self.app.router.customEventThemeColorEditItem(this.options.localSetting.attributes.EventId, scroll, this.model.attributes.id, this.model.attributes.ListOrig);
    },
    iDeleteClick: function (event) {
        var self = this;

        event.preventDefault();

        var dialog2ButtonModel = new Entities_Empty.Model();
        dialog2ButtonModel.attributes.Title = resources.X101344;
        dialog2ButtonModel.attributes.Text = resources.X101367;
        dialog2ButtonModel.attributes.Button01 = resources.X100281;
        dialog2ButtonModel.attributes.Button02 = resources.X100282;
        var dialog2Button = new View_Dialog2Button2({ model: dialog2ButtonModel, parent: this });

        var callback01 = function (options) {
            this.stopListening(dialog2Button, "dialog:btn01clicked", callback01);
            this.stopListening(dialog2Button, "dialog:btn02clicked", callback02);

            this.model.collection.remove(this.model);

            var customModule = self.app.entities.collections.customModule.where({ EventId: self.options.localSetting.attributes.EventId, ModuleType: 98 })[0];
            var data = JSON.parse(customModule.attributes.Data);
            var customModule_data = new Entities_Memory.Model(data[0].Data);
            var tmpCollection = new Entities_Memory_PositionPageable.Collection(data[0].Data.ThemeCollection);

            customModule_data.attributes.ThemeCollection = self.options.mainCollection.toJSON();
            var strJson = JSON.stringify(customModule_data.toJSON());
            customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

            customModule.save(customModule.attribute, {
                silent: false,
                wait: true,
                success: function () {
                }
            });
        }
        this.listenTo(dialog2Button, "dialog:btn01clicked", callback01);

        var callback02 = function (options) {
            this.stopListening(dialog2Button, "dialog:btn01clicked", callback01);
            this.stopListening(dialog2Button, "dialog:btn02clicked", callback02);
        }
        this.listenTo(dialog2Button, "dialog:btn02clicked", callback02);

        this.app.dialogRegion2.show(dialog2Button);
    },
    setupCss: function () {
        var MenuColorApp_BackGround = 'rgba(50,115,32,1)';
        //var BackGroundColorApp = 'rgba(221,221,221,1)'; grey make all white more easy
        var BackGroundColorApp = 'rgba(255,255,255,1)';
        var MenuColorApp_ForeGround = 'rgba(0,0,0,1)';

        //var MenuColorApp_Font = 'Roboto,sans-serif';
        var MenuColorApp_Font = 'Open Sans';
        //var MenuColorApp_Font = 'Abril Fatface';

        var MenuColorApp_FontSize_Header01 = '20px';
        var MenuColorApp_FontSize_Header02 = '16px';
        var MenuColorApp_FontSize_Footer = '12px';

        var Font1 = 'Open Sans';
        var Font1_Color = 'rgb(0, 0, 0)';
        var Font1_Size = '50px';
        var Font2 = 'Open Sans';
        var Font2_Color = 'rgb(0, 0, 0)';
        var Font2_Size = '40px';

        //var MenuColorApp_BackGround = 'rgba(38,173,228,1)';
        //var BackGroundColorApp = 'rgba(255,255,255,1)';
        //var MenuColorApp_ForeGround = 'rgba(0,0,0,1)';
        //var Font1 = 'Abril Fatface';
        //var Font1_Color = 'rgb(0, 0, 0)';
        //var Font2 = 'Abril Fatface';
        //var Font2_Color = 'rgb(0, 0, 0)';

        //var MenuColorApp_BackGround = 'rgba(255,0,0,1)';
        //var BackGroundColorApp = 'rgba(255,255,255,1)';
        //var MenuColorApp_ForeGround = 'rgba(0,0,0,1)';
        //var Font1 = 'Abril Fatface';
        //var Font1_Color = 'rgb(0, 0, 0)';
        //var Font2 = 'Abril Fatface';
        //var Font2_Color = 'rgb(0, 0, 0)';

        //var rgb = this.rgba2rgb(this.model.attributes.MenuColorApp_ForeGround);
        var rgb = this.rgb2rgb(this.model.attributes.MenuColorApp_ForeGround);
        this.model.attributes.MenuColorApp_ForeGround02 = String.format('rgba({0},{1},{2},0.9', rgb[0], rgb[1], rgb[2]);
        this.model.attributes.MenuColorApp_ForeGround03 = String.format('rgba({0},{1},{2},0.7', rgb[0], rgb[1], rgb[2]);

        this.ui.e4us_maincolor_01.css('background-color', this.model.attributes.MenuColorApp_BackGround);
        this.ui.e4us_maincolor_02.css('background-color', this.model.attributes.MenuColorApp_BackGround);
        this.ui.e4us_maincolor_02.css('color', this.model.attributes.MenuColorApp_ForeGround);


        this.ui.e4us_maincolor_03.css('background-color', this.model.attributes.BackGroundColorApp);

        this.ui.e4us_backgroundcolor_01.css('background-color', this.model.attributes.BackGroundColorApp);
        this.ui.e4us_backgroundcolor_02.css('background-color', this.model.attributes.BackGroundColorApp);

        this.ui.e4us_navbar_toggler_01.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        var s = String.format("data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='{0}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e", this.model.attributes.MenuColorApp_ForeGround);
        this.ui.e4us_navbar_toggler_icon.css('background-image', String.format('url("{0}"', s));
        this.ui.e4us_menucolor02_01.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor02_02.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor02_03.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor02_04.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor02_05.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor01_01.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_02.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_03.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_04.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_05.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_06.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_07.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_08.css('color', this.model.attributes.MenuColorApp_ForeGround02);

        this.ui.windowMenu_icon01.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon02.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon03.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon04.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon05.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon06.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon07.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon08.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon09.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon10.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon11.css('color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_icon12.css('color', this.model.attributes.MenuColorApp_ForeGround);

        this.ui.windowMenu_a01.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a02.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a03.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a04.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a05.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a06.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a07.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a08.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a09.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a10.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a11.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        this.ui.windowMenu_a12.css('border-color', this.model.attributes.MenuColorApp_ForeGround);

        this.ui.windowMenu_div.css('background-color', this.model.attributes.MenuColorApp_BackGround);

        this.ui.region001_1.css('background-color', this.model.attributes.BackGroundColorApp);
        this.ui.region001_1.css('border-color', this.model.attributes.MenuColorApp_BackGround);
        this.ui.region001_2.css('background-color', this.model.attributes.BackGroundColorApp);
        this.ui.region001_2.css('border-color', this.model.attributes.MenuColorApp_BackGround);
        this.ui.region001_3.css('background-color', this.model.attributes.BackGroundColorApp);
        this.ui.region001_3.css('border-color', this.model.attributes.MenuColorApp_BackGround);

        this.ui.hfont_01.css('font-family', this.model.attributes.Font1);
        this.ui.hfont_01.css('color', this.model.attributes.Font1_Color);
        this.ui.hfont_01.css('font-size', this.model.attributes.Font1_Size);
        this.ui.hfont_01.css('color', this.model.attributes.Font1_Color);
        this.ui.hfont_02.css('font-family', this.model.attributes.Font1);
        this.ui.hfont_02.css('color', this.model.attributes.Font1_Color);
        this.ui.hfont_02.css('font-size', '50px');
        this.ui.hfont_03.css('font-family', this.model.attributes.Font1);
        this.ui.hfont_03.css('color', this.model.attributes.Font1_Color);
        this.ui.hfont_03.css('font-size', '40px');
        this.ui.hfont_04.css('font-family', this.model.attributes.Font1);
        this.ui.hfont_04.css('color', this.model.attributes.Font1_Color);
        this.ui.hfont_04.css('font-size', '30px');

        this.ui.pfont_01.css('font-family', this.model.attributes.Font2);
        this.ui.pfont_01.css('color', this.model.attributes.Font2_Color);
        this.ui.pfont_01.css('font-size', this.model.attributes.Font2_Size);
        this.ui.pfont_02.css('font-family', this.model.attributes.Font2);
        this.ui.pfont_02.css('color', this.model.attributes.Font2_Color);
        this.ui.pfont_02.css('font-size', '20px');



        this.ui.e4us_maincolor_01.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_01.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_02.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_03.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_04.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_05.css('font-family', this.model.attributes.MenuColorApp_Font);

        this.ui.e4us_maincolor_02.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header01);

        this.ui.e4us_maincolor_01.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_01.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_02.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_03.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_04.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_05.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);

        this.ui.e4us_menucolor01_01.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_02.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_03.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_04.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_05.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_06.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_07.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_08.css('font-family', this.model.attributes.MenuColorApp_Font);


        this.ui.e4us_menucolor01_01.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_02.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_03.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_04.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_05.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_06.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_07.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_08.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);



        this.ui.e4us_menucolor02_01.hover(
            function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround02);
            }, function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround03);
            }
        );

        this.ui.e4us_menucolor02_02.hover(
            function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround02);
            }, function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround03);
            }
        );

        this.ui.e4us_menucolor02_03.css('background-color', this.model.attributes.MenuColorApp_BackGround);//'rgba(50,115,32,1)');
        this.ui.e4us_menucolor02_03.hover(
            function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround02);
            }, function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround03);
            }
        );

        this.ui.e4us_menucolor02_04.css('background-color', this.model.attributes.MenuColorApp_BackGround);//'rgba(50,115,32,1)');
        this.ui.e4us_menucolor02_04.hover(
            function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround02);
            }, function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround03);
            }
        );
    },
    trim: function (str) {
        return str.replace(/^\s+|\s+$/gm, '');
    },
    rgb2rgb: function (/*rgb,*/ rgb) {
        var inParts = rgb.substring(rgb.indexOf("(")).split(","),
            r = parseInt(this.trim(inParts[0].substring(1)), 10),
            g = parseInt(this.trim(inParts[1]), 10),
            b = parseInt(this.trim(inParts[2]), 10)
        var outParts = [
            r,
            g,
            b
        ];

        // Pad single-digit output values


        return outParts;
    },
});